import { render, staticRenderFns } from "./cardEntityChannelsDiff.vue?vue&type=template&id=4a49d6dc"
import script from "./cardEntityChannelsDiff.vue?vue&type=script&lang=js"
export * from "./cardEntityChannelsDiff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports